import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { z } from 'zod'

interface ZodPhoneNumberOptions {
  required?: boolean
}

export function zPhoneNumber(options?: ZodPhoneNumberOptions) {
  return z
    .string()
    .nullish()
    .transform((value, ctx) => {
      if (value?.trim()) {
        const phoneNumber = parsePhoneNumberFromString(value, {
          defaultCountry: 'US',
          extract: false,
        })

        if (phoneNumber?.isValid()) {
          return phoneNumber.formatNational()
        }

        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid phone number',
        })
      } else if (options?.required) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Phone number is required',
        })
      }

      return value
    })
}
